import {EventBus} from '@/event-bus.js'

const Covid19icons = {
  methods: {
    getConcerningDevelopmentsIcon (canvas, size) {
      size = size === undefined ? 20 : size
      let group = canvas.group()
      let circle = canvas.circle(size)
        .fill('#F23411')
        .stroke({ color: '#efefef', width: size / 20 })
        .move(0, 0)

      let text = canvas.text('!')
        .font({
          fill: '#fff',
          anchor: 'middle',
          leading: 1,
          size: (size / 4 * 3),
          family: 'Yrsa',
          weight: 500
        })
        .attr('alignment-baseline', 'middle')
        .attr('dominant-baseline', 'middle')

      text.move((size / 2), (size / 20))
      group.add(circle)
      group.add(text)
      group.addClass('concerningDevelopmentsIcon')

      return group
    },

    getDevelopmentsToWatchIcon (canvas, size) {
      size = size === undefined ? 20 : size

      let group = canvas.group()
      let circle = canvas.circle(size)
        .fill('#fff')
        .stroke({ color: '#efefef', width: (size / 10) })
        .move(0, 0)

      let circle1 = canvas.circle((size / 2.85))
        .stroke({ color: '#004C64', width: (size / 11.67) })
        .fill('none')
        .move((size / 4), (size / 4))

      let rect = canvas.rect((size / 3.333), (size / 10))
        .fill('#004c64')
        .rotate(45)
        .move((size / 4 * 3), (size / 14.29))

      group.add(circle)
      group.add(circle1)
      group.add(rect)
      group.addClass('developmentsToWatchIcon')

      return group
    }
  }
}

const FrameworkWheelMixins = {
  data () {
    return {
      covidicons: [],
      covid19AttributeDegrees: [
        { name: 'SA_01_01', deg: 9 }, // Start: 0. Size 18
        { name: 'SA_01_02', deg: 27 },
        { name: 'SA_01_03', deg: 45 },
        { name: 'SA_01_04', deg: 63 },
        { name: 'SA_02_01', deg: 84 }, // Start: 72. Size 24
        { name: 'SA_02_02', deg: 108 },
        { name: 'SA_02_03', deg: 132 },
        { name: 'SA_03_01', deg: 156 }, //  Start 144. Size 24
        { name: 'SA_03_02', deg: 180 },
        { name: 'SA_03_03', deg: 204 },
        { name: 'SA_04_01', deg: 234 }, // Start 216. Size 36
        { name: 'SA_04_02', deg: 270 },
        { name: 'SA_05_01', deg: 297 }, // Start 288. Size 18
        { name: 'SA_05_02', deg: 315 },
        { name: 'SA_05_03', deg: 333 },
        { name: 'SA_05_04', deg: 351 }
      ]
    }
  },
  destroyed () {
    this.removeTooltips()
  },
  methods: {
    setCovid19AttributeIcons () {
      if (
        !this.$store.state.covid19.is_enabled ||
        !this.firstCountry ||
        !this.firstCountry.id ||
        !this.canvas
      ) {
        return false
      }

      for (const attrDeg of this.covid19AttributeDegrees) {
        let attr = this.$store.getters['covid19/countryAttributeType'](this.firstCountry.id, attrDeg.name)

        if (attr) {
          let d = attrDeg.deg - 90 // the entire circle is rotate backwards 90deg
          let pos = this.getCovid19AttributeIconPosition(d)
          let x = pos.x - 10 + this.canvasSize[0] / 2
          let y = pos.y - 10 + this.canvasSize[1] / 2
          let icon = attr === 'watch' ? this.getDevelopmentsToWatchIcon(this.canvas) : this.getConcerningDevelopmentsIcon(this.canvas)

          icon.move(x, y)
          this.groups.push(icon)
          this.covidicons.push(icon)
          this.addTooltip(icon, attr)
        }
      }
    },

    addTooltip (icon, attr) {
      icon.on('mouseover', () => {
        let txt
        if (attr === 'high') {
          txt = this.$Strings('covid19_concerning_tooltip')
        } else {
          txt = this.$Strings('covid19_watch_tooltip')
        }
        EventBus.$emit('tooltip.show', {
          style: 'multiline',
          label: (attr === 'watch' ? 'Developments to watch' : 'Concerning developments'),
          value: [ '<span class="text-sm">' + txt + '</span>' ]
        })
      })
      icon.on('mouseout', () => {
        EventBus.$emit('tooltip.hide')
      })
    },

    removeTooltips () {
      EventBus.$emit('tooltip.hide')
      for (const icon of this.covidicons) {
        icon.off()
      }
    },

    getCovid19AttributeIconPosition (deg, isSubattribute = 0) {
      let c = this.canvasSize[1]
      let r = (c / 2) - 84 // or 10 if it should go on edge
      let radian = deg * (Math.PI / 180)

      return {
        x: Math.cos(radian) * r,
        y: Math.sin(radian) * r
      }
    }
  }
}

export { Covid19icons, FrameworkWheelMixins }



// WEBPACK FOOTER //
// ./src/components/covid19/FrameworkWheelMixins.js